import './modules/polyfills';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as Utils from './modules/utils';
import './modules/navigation';
import * as Ajax from './modules/ajax';

Utils.buildPage();

if (document.querySelector('.js-scroll-to-section')) {
    Utils.scrollToTarget('.js-scroll-to-section', 81);
}

// Ajax load more
if (document.querySelector('.js-load-more-posts')) {
    Ajax.init();
}
